import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const keyToMigrate = 'otherValuables';

const migrateAssetOtherValuables = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };
  const value = newData[keyToMigrate];

  if (value && !Array.isArray(value)) {
    newData[keyToMigrate] = [value];
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateAssetOtherValuables },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration11: MigrationType = {
  migrate,
  version: 12,
};
